const BaseMinorAnimationTypes = [
    'sway-x',
    'sway-y',
    'shake',
    'pulse',
    'spin',
];

const commonMinorAnimationTypes = [
    'sway-x',
    'sway-y',
    'shake',
    'spin',
];

export const MinorAnimationTypes = [
    // 'none',
    ...BaseMinorAnimationTypes,
    ...commonMinorAnimationTypes,
    ...commonMinorAnimationTypes,
]